import { Component } from "@angular/core";
import { Button } from "@ankaadia/ankaadia-shared-frontend";
import { FieldType } from "@ngx-formly/core";
import { FormElementMapModule } from "../../shared/from-element-map/form-element-map.module";
@Component({
  selector: "app-formly-button",
  imports: [Button, FormElementMapModule],
  templateUrl: "./formly-button.component.html",
})
export class FormlyButtonComponent extends FieldType {}
